export function shouldTrackSubscribeConsentDialogExposure(previousOpen: boolean, open: boolean) {
  return open && !previousOpen;
}
